import * as React from 'react';

import type { ClientsClient } from '@/api/clients-client';
import { HttpClientsClient } from '@/api/clients-client.http';

// Impl HTTP réelle par défaut (Phase 2, D2a-LECT) : le stub reste injectable via le
// provider pour les tests. Instance partagée (sans état interne).
const defaultClientsClient: ClientsClient = new HttpClientsClient();

// =============================================================================
// clients-client-context.tsx — Injection du ClientsClient (DI seam, S6).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut : le StubClientsClient (stub-first).
//
// Contexte AUTO-PORTÉ par le BC client-reference : il n'est PAS branché dans le
// providers.tsx global (surface partagée gelée en parallélisme S5bis∥S6) — la route
// `/admin/clients` enveloppe son écran avec ce provider localement. Le défaut de
// contexte = le stub, de sorte que l'écran fonctionne hors provider explicite.

const ClientsClientContext =
  React.createContext<ClientsClient>(defaultClientsClient);

export interface ClientsClientProviderProps {
  client?: ClientsClient | undefined;
  children: React.ReactNode;
}

export function ClientsClientProvider({
  client = defaultClientsClient,
  children,
}: ClientsClientProviderProps): React.JSX.Element {
  return (
    <ClientsClientContext.Provider value={client}>
      {children}
    </ClientsClientContext.Provider>
  );
}

export function useClientsClient(): ClientsClient {
  return React.useContext(ClientsClientContext);
}
